export default {
  slug: "mps",
  code: "MPS",
  label: "MPS",
  krakenDir: "MPS",
  logoFamily: "jb",
};
